

$(window).scroll(function () {
  if ($(this).scrollTop() > 10) {
    $(".hdr_sec").addClass("fixed");
  } else {
    $(".hdr_sec").removeClass("fixed");
  }
});


// education-slider

$(document).ready(function () {

  // Initialise the education slider
  $('.education-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,       // using custom arrows below
    dots: false,
    centerMode: true,
    centerPadding: '0px',
    infinite: true,
    speed: 500,
    cssEase: 'ease',
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  });

  // Custom arrow bindings
  $('.edu-arrow--prev').on('click', function () {
    $('.education-slider').slick('slickPrev');
  });

  $('.edu-arrow--next').on('click', function () {
    $('.education-slider').slick('slickNext');
  });

});
// education-slider
document.addEventListener('DOMContentLoaded', function () {
  const video = document.querySelector('.banner-video');
  const volumeBtn = document.querySelector('.video-volume-btn');

  if (!video || !volumeBtn) return;

  // Try unmuted autoplay first
  video.muted = false;

  video.play()
    .then(function () {
      // Unmuted autoplay succeeded
      volumeBtn.textContent = '🔊';
    })
    .catch(function () {
      // Browser blocked unmuted autoplay — fall back to muted
      video.muted = true;
      video.play();
      volumeBtn.textContent = '🔇';
    });

  volumeBtn.addEventListener('click', function () {
    video.muted = !video.muted;
    volumeBtn.textContent = video.muted ? '🔇' : '🔊';
  });
});